const Toggler = {
    toggleSideOverlay: function() {
      const ref = document.querySelector("#page-container").classList;
      ref.toggle("side-overlay-o");
    }
  }

export default Toggler;
